import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'reactstrap';
import AUX from '../../../../hoc/Aux_';
import { useDispatch, useSelector } from 'react-redux';
import {
  getTitle,
  getMember,
  addTitle,
  editTitle,
  AddTitleMember,
  deleteMemberTitle,
} from '../../../../redux/MainAction';
import Swal from 'sweetalert2';

const MemberTitleDrop = () => {
  const dispatch = useDispatch();
  const tmlist = useSelector((state) => state.Webtracker.title);
  const user = useSelector((state) => state.Webtracker.member);
  const inputRef = useRef(null);

  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [newteam, setNewTeam] = useState('');

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    const data = { offset: 0, limit: 100 };
    dispatch(getTitle(data));
    dispatch(getMember());
  };

  useEffect(() => {
    if (tmlist && tmlist.rows) setTeams(tmlist.rows);
    if (user && user.rows) setUsers(user.rows);
  }, [tmlist, user]);

  const handleDragStart = (e, userId) => {
    e.dataTransfer.setData('userId', userId);
  };

  const handleDrop = async (e, teamId) => {
    e.preventDefault();
    e.stopPropagation();

    const userId = e.dataTransfer.getData('userId');
    if (!userId) return;

    const payload = {
      titleId: teamId,
      userId: userId,
    };

    await dispatch(AddTitleMember(payload));
    dispatch(getTitle());
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const newTeamRef = useRef(null);
  const [teamJustAdded, setTeamJustAdded] = useState(false);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && newteam.trim()) {
      dispatch(addTitle({ name: newteam.trim() }));
      setNewTeam('');
      setTeamJustAdded(true);
    }
  };

  const createTitleHandler = (e) => {
    if (newteam.trim()) {
      dispatch(addTitle({ name: newteam.trim() }));
      setNewTeam('');
      setTeamJustAdded(true);
    }
  };

  useEffect(() => {
    if (teamJustAdded && newTeamRef.current) {
      newTeamRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTeamJustAdded(false);
    }
  }, [teams]);

  const handleAddNewTeamClick = () => {
    if (inputRef.current) inputRef.current.focus();
  };

  const onRemoveTeamUser = async (teamId, userId) => {
    await dispatch(deleteMemberTitle({ titleId: teamId, userId }));
    dispatch(getTitle());
  };

  const onRemoveTeam = (id) => {
    if (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then((confirm) => {
        if (confirm.isConfirmed) {
          dispatch(editTitle({ id, status: 'DELETED' }));
        }
      });
    }
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-2">
          <h5 className="text-muted col-4"></h5>
          <div className="col-8 d-flex justify-content-end align-items-center">
            <Button size="sm" color="dark" onClick={handleAddNewTeamClick}>
              + Add New Title
            </Button>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-8 team_items">
              {teams.map((team, index) => (
                <div
                  key={team.id}
                  className="d-flex team_list mb-2"
                  ref={index === 0 ? newTeamRef : null}
                >
                  <span>
                    <i className="mdi mdi-drag-vertical font-size-20 pointer"></i>
                  </span>
                  <div className="card w-100 no-drag shadow-none">
                    <div className="card-body d-flex flex-column">
                      <div className="d-flex justify-content-between align-items-center">
                        <b className="font-18">{team?.name}</b>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ width: '4vw' }}
                        >
                          <span>
                            <i className="mdi mdi-account-multiple mr-1"></i>{' '}
                            {team?.memberTitles?.length || 0}
                          </span>
                          <i
                            className="fa fa-trash-o font-20 remove_team"
                            onClick={() => onRemoveTeam(team.id)}
                          ></i>
                        </div>
                      </div>
                      <div className="card-body">
                        <div
                          className="row show_user"
                          onDrop={(e) => handleDrop(e, team.id)}
                          onDragOver={handleDragOver}
                        >
                          {team.memberTitles.length > 0 ? (
                            team?.memberTitles.map((member, idx) => (
                              <div
                                key={idx}
                                className="d-flex flex-column align-items-center user_card"
                              >
                                <div
                                  className="remove_user"
                                  onClick={() =>
                                    onRemoveTeamUser(team?.id, member?.userId)
                                  }
                                >
                                  <i className="mdi mdi-window-close"></i>
                                </div>
                                <span className="user_name">
                                  {member?.user?.firstName.charAt(0)}
                                  {member?.user?.lastName.charAt(0)}
                                </span>
                                <span className="font-14">
                                  {member?.user?.firstName}{' '}
                                  {member?.user?.lastName}
                                </span>
                              </div>
                            ))
                          ) : (
                            <div className="square-block drop-here d-flex justify-content-center align-items-center">
                              Drag and drop your title members here
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="card add_new_team">
                <input
                  ref={inputRef}
                  type="text"
                  className="addTeam"
                  placeholder="Write title name"
                  value={newteam}
                  onChange={(e) => setNewTeam(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </div>
              <div className="text-right my-3">
                <Button onClick={createTitleHandler}>Add Title</Button>
              </div>
            </div>
            <div className="card col-xl-4 users_list">
              <div className="m-4">
                <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-toggle="tab"
                      href="#add_time"
                      role="tab"
                    >
                      <span className="d-none d-md-block">All Members</span>
                      <span className="d-block d-md-none">
                        <i className="mdi mdi-home-variant h5"></i>
                      </span>
                    </a>
                  </li>
                </ul>
                <div className="tab-content mt-2">
                  <div
                    className="tab-pane active"
                    id="add_time"
                    role="tabpanel"
                  >
                    <div className="user_main mt-5 ml-2">
                      {users.map((itm) => (
                        <div
                          key={itm.id}
                          className="d-flex flex-column justify-content-center align-items-center user_card"
                          draggable
                          onDragStart={(e) => handleDragStart(e, itm.id)}
                        >
                          <span className="user_name">
                            {itm.firstName.charAt(0)}
                            {itm.lastName.charAt(0)}
                          </span>
                          <span className="font-14">
                            {itm.firstName} {itm.lastName}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default MemberTitleDrop;
